import React, { useState,useRef, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import axios from 'axios';
import { Button, Grid, Typography, CircularProgress, Divider } from "@mui/material";
import {updatePoObj} from '../../../store/slice/PharmaSlice'

const UploadPO = () => {
    const dispatch = useDispatch();
    const [apiInProgress, setApiInProgress] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadResult, setUploadResult] = useState("NA");
    const {poDashboard} = useSelector((state)=>state.pharmaslice);
    const {poObj} = useSelector((state)=>state.pharmaslice.poDashboard);
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState('');
    
    useEffect(()=>{
    },[poObj])
    const handleFileChange = (event) => {
        setUploadResult('NA');
        setSelectedFile(event.target.files[0]);
    };

    const handlePoUploadSuccess = (responseObj)=>{
        setApiInProgress(false);
        setUploadResult("SUCCESS");
        setSelectedFile(null);
        dispatch(updatePoObj(responseObj.poInfo));
        console.log("responseObj=>"+JSON.stringify(responseObj));
    }
    const handlePoUploadFailure = (errorObj)=>{
        console.log("errorObj=>"+JSON.stringify(errorObj));
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            alert("Please select a file first!");
            return;
        }
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('poid', poDashboard.selectedId);
        setApiInProgress(true);
        setFileName(selectedFile.name);
        const token = localStorage.getItem("JWT");
        try {
            const response = await axios.post('https://appmachine.in/dam-core-service/assetmgmtextn/uploadpo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}` 
                },
            });
            handlePoUploadSuccess(response.data);
        } catch (error) {
            handlePoUploadFailure(error);
        }
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const getFileContainerMessage = () =>{
        
        if (uploadResult==="SUCCESS"){
            return "PO '"+fileName+"' is uploaded successfully";
        }
        
    }
    const getComponent = () =>{
        if (selectedFile!==null){
            return <Typography variant="h6"><i>Selected File Name is '{selectedFile.name}'</i></Typography>
        } else {
            if (poObj.popath!==''){
                return <iframe
                src={`https://docs.google.com/gview?embedded=true&url=${poObj.popath}`}
                width="100%"
                style={{ height: '55vh', width: '100%', border: 'none' }}
                title="PO @ {poObj.partyname}"
              />
            } else {
                return <Typography variant="h6"><i>PO is not uploaded, yet</i></Typography>
            }
        }
    }
    return (
        poDashboard.selectedId!==-1?
            <>
                <form onSubmit={handleSubmit}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        sx={{ 
                            width:{xs: window.screen.width-50, lg:window.screen.width-250},
                            //height:{xs:window.screen.height-150+'px'}
                        }}
                        xs={12}
                        
                        >
                            <input type="file" accept="application/pdf" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }}/>
                            <Grid item lg="12" xs={11} sx={{backgroundColor:'#d9d9d9', textAlign: 'center', width:'100%'}} >
                                {getComponent()}
                            </Grid>
                            <Grid item lg="12" xs={11} >
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{backgroundColor:'white',}}
                                    padding={1}
                                    >
                                        <Grid item xs={12}>
                                        <Typography variant="h6"><i>{getFileContainerMessage()} </i></Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Button variant="outlined" onClick={handleButtonClick}>{selectedFile===null?'Select PO':'Change PO'}</Button>
                                        </Grid> 
                                        <Grid item sx={{ height:'15px'}}>
                                        </Grid> 
                                        <Grid item xs={12}>
                                            {apiInProgress?
                                                <CircularProgress />:
                                                <Button variant="outlined" disabled={selectedFile===null?true:false} onClick={handleSubmit}>Upload</Button>
                                            }
                                        </Grid>
                                </Grid>
                            </Grid>
                    </Grid>
                </form>
            </>
        : <>NOT SELCTED</>
    );
};

export default UploadPO;
